import React from "react";
import { useNavigate } from "react-router-dom";

// 클로즈 메시지 컴포넌트
const CloseMessage = ({ message, openCloseChatModal, makeEventTrackFn }) => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center w-full pt-16 mt-16 border-t border-gray-300 mb-7">
      <div className="px-9 py-3.5 bg-neutral-400 rounded-[30px] justify-center items-center gap-1 inline-flex flex-col text-white">
        <p className="text-center break-keep">{message}</p>
        <button
          className="font-medium underline"
          onClick={() => {
            openCloseChatModal();
            makeEventTrackFn({
              category: "event",
              action: "디지털상담으로 돌아가기",
            });
          }}
        >
          디지털상담으로 돌아가기
        </button>
      </div>
    </div>
  );
};

export default CloseMessage;
